import React from 'react';
import PropTypes from 'prop-types';
var DrawingControlsTooltip = function(param) {
    var text = param.text;
    return /*#__PURE__*/ React.createElement("div", {
        className: "draw-tooltip"
    }, text);
};
DrawingControlsTooltip.propTypes = {
    text: PropTypes.string.isRequired
};
export default DrawingControlsTooltip;
